module.exports = __webpack_public_path__ + "img/ExchangePoint.9f333bad.png";